// extracted by mini-css-extract-plugin
export default {"request_box":"request_request_box__p3yAc","btn":"request_btn__KwqE2","grid_6":"request_grid_6__XZPhx","btn_left":"request_btn_left__RYFGZ"};